import {FIGURE_CLASS} from './constants';

export const initCdsvideo = ( figure, container ) => {
	const iframe = document.createElement( 'iframe' );

	iframe.src = container.dataset.videoSrc;
	iframe.setAttribute( 'allowfullscreen', true );
	iframe.setAttribute( 'allowautoplay', true );
	iframe.setAttribute( 'loading', 'lazy' );
	container.before( iframe );
	container.remove();

	const handleInitClick = () => {
		figure.classList.add( FIGURE_CLASS.CLICKED );
		figure.classList.remove( FIGURE_CLASS.SHOW_COVER );
		figure.classList.remove( FIGURE_CLASS.SHOW_VIDEO_COVER );
		iframe.src += iframe.src.split('?')[1] ? '&autoplay' : '?autoplay';
		figure.removeEventListener( 'click', handleInitClick );
	};

	figure.classList.add( FIGURE_CLASS.LOADED );
	figure.classList.remove( FIGURE_CLASS.LOADING );
	figure.addEventListener( 'click', handleInitClick );
};
